import React, { useState, useEffect } from 'react'
import { Panel, Message } from 'rsuite'
import { Input, Form } from 'rsuite'
import CheckboxColForm from '../../../components/forms/checkboxColForm/CheckboxColForm'
import {
  isRequired,
  isValidators,
  isRequiredFiled,
  getMaxLengthData,
} from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import ShowLimitLength from '../../../components/utils/ShowLimitLength'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'

export default function ChkAreaSetting({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  isConfirmActualResult,
}) {
  const [schema, setSchema] = useState(_schema)
  const [textLength, setTextLength] = useState(schema?.areaCriteria?.value?.length || 0)

  return (
    <>
      <Form>
        <Panel accordion bodyFill>
          {isConfirmActualResult ? (
            <>
              <Panel header="" defaultExpanded>
                <b>{schema.areaCriteria.label} : </b>
                <br />
                <p style={{ padding: 20 }}>{schema?.areaCriteria?.value ?? ''}</p>
              </Panel>
            </>
          ) : (
            <>
              <Panel header="" defaultExpanded>
                {schema.description && <CustomAlertMessageInfo contents={schema.description} />}

                <br />
                <Message showIcon type="warning" description={schema.areaCriteria.alert} />
                <br />
                <label className={isRequired(schema.areaCriteria.validators) ? 'required' : ''}>
                  {schema.areaCriteria.label}
                </label>
                <ErrorMessage error={errors[schema.areaCriteria.name]} />
                <Input
                  componentClass="textarea"
                  rows={3}
                  // maxLength="1000"
                  name={schema.areaCriteria.name}
                  inputRef={register(isValidators(schema.areaCriteria.validators))}
                  defaultValue={schema.areaCriteria.value}
                  placeholder={schema.areaCriteria.hint}
                  disabled={schema.areaCriteria.disabled}
                  maxLength={getMaxLengthData(schema.areaCriteria.validators)?.value}
                  onChange={(e) => {
                    setTextLength(e.length)
                    //   schema.areaCriteria.value = e
                    //   updateSchemaValue()
                  }}
                />
                <ShowLimitLength
                  textLength={textLength}
                  maxLength={getMaxLengthData(schema.areaCriteria.validators)?.value}
                />
              </Panel>
            </>
          )}

          {/* <Panel
            header={isRequiredFiled(
              isRequired(schema.areaSetting.validators),
              schema.areaSetting.label
            )}
          > */}
          <CheckboxColForm
            schema={schema.areaSetting}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            getValues={getValues}
            column={3}
          ></CheckboxColForm>
          {/* </Panel> */}
        </Panel>
      </Form>
    </>
  )
}
